import React, { useRef, useState } from 'react';
import styled from 'styled-components/macro';
import vw from 'rpf/un/vw';
import vwToPx from 'rpf/un/vwToPx';
import Modal from 'components/Modal';
import CloseBtn from 'components/CloseBtn';
import Alert from 'components/Alert';
import ProtocolModal from './ProtocolModal';

import autobg from 'autobg.macro';
import api from 'api';

const vpx = val => vwToPx(vw(val)) + 'px';

const Wrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: ${vw(690)};
  height: ${vw(868)};
  background-color: #ffffff;
  border-radius: ${vw(20)};
`;

const Title = styled.div`
  ${autobg('assets/img/home/sign_title.png')}
  margin-top: ${vw(76)};
`;

const OptionsWrap = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  margin-top: ${vw(66)};
  padding: 0 0 0 ${vw(44)};
`;

const OptionWrap = styled.div`
  display: flex;
  align-items: center;
  font-size: ${vw(32)};
  color: #2c2d40;
`;

const Option = styled.div`
  position: relative;
  width: ${vpx(30)};
  height: ${vpx(30)};
  margin-right: ${vw(12)};
  border: 1px solid #2b4bab;
`;

const OptionIn = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: #2b4bab;
`;

const OptionTips = styled.div`
  font-size: ${vw(32)};
  color: #a0a0a0;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: ${vw(612)};
  height: ${vw(348)};
  margin-top: ${vw(37)};
`;

const InputWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const Input = styled.input`
  flex: 1;
  height: ${vw(83)};
  margin-bottom: ${vw(33)};
  padding: 0 ${vw(27)};
  border-radius: ${vw(10)};
  border: 1px solid #dcdcde;
  font-size: ${vw(28)};
`;

const Pic = styled.img`
  width: ${vw(194)};
  height: ${vw(83)};
  margin-left: ${vw(29)};
  border-radius: ${vw(10)};
  border: 1px solid #dcdcde;
`;

const Tips = styled.div`
  position: relative;
  width: 100%;
  padding: 0 ${vw(40)};
  font-size: ${vw(28)};
  color: #a0a0a0;
  line-height: 1.4;
  text-indent: 1.4em;
  span {
    color: #4460b7;
  }
`;

const TipsOption = styled.div`
  position: absolute;
  left: ${vw(40)};
  top: ${vw(2)};
  display: inline-block;
  border: 1px solid #2b4bab;
`;

const TipsOptionIn = styled.div`
  position: absolute;
  left: ${vw(-2)};
  top: ${vw(-7)};
  ${autobg('assets/img/home/tick.png')}
`;

const SubmitBtn = styled.div`
  ${autobg('assets/img/home/btn_submit.png')}
  margin-top: ${vw(40)};
`;

const SignModal = ({ open, onClose, onSuccess }) => {
  const [options, setOptions] = useState({ back: false, new: false });

  const [error, setError] = useState({ show: false, text: '' });

  const [isReadRule, setIsReadRule] = useState(false);

  const [showProtocol, setShowProtocol] = useState(false);

  const [picUrl, setPicUrl] = useState(() => api.getPic());
  const handleUpdatePic = () => {
    setPicUrl(`${api.getPic()}&t=${Date.now()}`);
  };

  const [values, setValues] = useState({
    mobile: '',
    identify: '',
    code: ''
  });
  const handleInputChange = event => {
    const { name, value } = event.target;
    setValues(s => ({ ...s, [name]: value }));
  };

  const lockRef = useRef(false);
  const handleSubmit = async () => {
    if (!values.identify) {
      return setError({
        show: true,
        text: '请输入身份证后4位'
      });
    }
    if (!values.mobile) {
      return setError({
        show: true,
        text: '请输入手机号码'
      });
    }
    if (!values.code) {
      return setError({
        show: true,
        text: '请输入图形验证码'
      });
    }
    if (!isReadRule) {
      return setError({
        show: true,
        text: '请阅读并同意遵守本次活动的《活动规则》及《隐私保护协议》'
      });
    }
    if (lockRef.current) return;
    lockRef.current = true;
    const [err] = await api.postVerify({ ...values });
    lockRef.current = false;
    if (err) {
      return setError({
        show: true,
        text: err.data.msg
      });
    }
    onSuccess({ ...values, createAccount: options.new, trading: options.back });
  };

  return (
    <Modal open={open}>
      <Wrap>
        <CloseBtn onClick={onClose} />
        <Title />
        <OptionsWrap>
          <OptionWrap
            style={{ marginRight: vw(93) }}
            onClick={() =>
              setOptions(s => {
                return { ...s, back: !s.back };
              })
            }
          >
            <Option
              style={{
                width: vpx(32),
                height: vpx(32)
              }}
            >
              {options.back && (
                <OptionIn style={{ width: vpx(20), height: vpx(20) }} />
              )}
            </Option>
            返现活动
          </OptionWrap>
          <OptionWrap
            style={{ marginRight: vw(22) }}
            onClick={() =>
              setOptions(s => {
                return { ...s, new: !s.new };
              })
            }
          >
            <Option
              style={{
                width: vpx(32),
                height: vpx(32)
              }}
            >
              {options.new && (
                <OptionIn style={{ width: vpx(20), height: vpx(20) }} />
              )}
            </Option>
            新开卡活动
          </OptionWrap>
          <OptionTips>(可多选)</OptionTips>
        </OptionsWrap>
        <Form>
          <Input
            name="identify"
            placeholder="请输入身份证后4位"
            maxLength={4}
            value={values.identify}
            onChange={handleInputChange}
          />
          <Input
            name="mobile"
            placeholder="请输入手机号码"
            maxLength={11}
            value={values.mobile}
            onChange={handleInputChange}
          />
          <InputWrap>
            <Input
              name="code"
              placeholder="请输入图形验证码"
              maxLength={4}
              value={values.code}
              onChange={handleInputChange}
            />
            <Pic src={picUrl} onClick={handleUpdatePic} />
          </InputWrap>
        </Form>
        <Tips>
          <TipsOption
            style={{
              width: vpx(32),
              height: vpx(32)
            }}
            onClick={() => setIsReadRule(s => !s)}
          >
            {isReadRule && <TipsOptionIn />}
          </TipsOption>
          我已仔细阅读并同意遵守本次活动的《活动规则》及
          <span onClick={() => setShowProtocol(true)}>《隐私保护协议》</span>
        </Tips>
        <SubmitBtn onClick={handleSubmit} />
      </Wrap>
      <Alert
        open={error.show}
        text={error.text}
        onClose={() => setError({ show: false })}
      />
      <ProtocolModal
        open={showProtocol}
        onClose={() => {
          setIsReadRule(true);
          setShowProtocol(false);
        }}
      />
    </Modal>
  );
};

export default SignModal;
